import React, { useEffect, useState } from 'react';
import '../../../index.scss';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';

// material
import Alert from '@material-ui/lab/Alert';
import { isType, isType3, isTypeBK, userTypeList } from 'main_consts';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import styled from 'styled-components';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { TableColumn } from 'components/NewTable/type';
import colW from 'components/NewTable/consts';
import NewTable from 'components/NewTable';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  checkboxChange,
  formatDateTime,
  getColWidthByField,
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  radioChange,
  selectChange,
  initWhrehhouse,
  getFindDropDownList,
  formatDate,
  postFindDropDownOneList,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getFindMawbNoList,
  getSearch,
  postExcelAndFunctionName,
  postSearch,
  snackBarRsp,
} from '../../../main_api';
import CheckBox from '../../../components/Material/Checkbox';

import Table from '../../../components/Material/Table/index';
import {
  Imaster,
  IshortOverLandedDetailList,
  IshortOverLandedList,
} from './type';
import Select from '../../../components/Material/Select';
import { Iobject, Ioption } from '../../../main_type';
import { MasterGrids } from '../../../components/MasterGrids/MasterGrids';

const DivStyle = styled.div`
  border: 3px outset #1c6ea4;
  margin-bottom: 1rem;
`;

/** 分提單查詢 */
const ShortOverLandedQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',
    // 日期
    declDate: getDateDayPlus(),
    // 短溢卸註記
    shortOverType: 'S',
    // 主號
    mawbNo: '',
    declDateValid: false,
  };

  const apiName = 'shortOverLandedQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [listCol, setListCol] = useState<TableColumn[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [rowData, setRowData] = useState<IshortOverLandedList[]>([]);
  const [mawbNoList, setMawbNoList] = useState<string[]>([]);
  const [colListDetail, setColListDetail] = useState<GridColDef[]>([]);
  const [listColDetail, setListColDetail] = useState<TableColumn[]>([]);
  const [rowDataDetail, setRowDataDetail] = useState<
    IshortOverLandedDetailList[]
  >([]);
  const [showDetail, setShowDetail] = useState(false);

  useEffect(() => {
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.topType, userType) ||
        isType(userTypeList.type1, userType) ||
        isType(userTypeList.type4, userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
  }, [userType]);

  const setDropDownList = () => {
    if (master.warehouse && master.declDate && master.shortOverType) {
      setMaster((prev) => ({
        ...prev,
        mawbNo: '',
      }));
      postFindDropDownOneList(apiName, 'findDropDownMawbNo', enqueueSnackbar, {
        warehouse: master.warehouse,
        declDate: master.declDate,
        shortOverType: master.shortOverType,
      }).then((item) => {
        setMawbNoList(item);
      });
    }
  };

  useEffect(() => {
    setDropDownList();
  }, [master.warehouse]);

  useEffect(() => {
    setDropDownList();
  }, [master.declDate]);

  useEffect(() => {
    setDropDownList();
  }, [master.shortOverType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postExcelAndFunctionName(
      apiName,
      'exportShortDetailExcelFile',
      {
        warehouse: master.warehouse,
        shortOverType: master.shortOverType,
        mawbNo: master.mawbNo,
        declDate: master.declDate,
      }
    );
    const declDate = formatDate(master.declDate, 'yyyyMMdd');

    blobDownload(result, enqueueSnackbar, `短卸分號明細報表.xlsx`);
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await postSearch(apiName, {
      warehouse: master.warehouse,
      shortOverType: master.shortOverType,
      mawbNo: master.mawbNo,
      declDate: master.declDate,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    const shortOverLandedReportList = result.data
      .data as IshortOverLandedList[];
    if (shortOverLandedReportList) {
      if ((shortOverLandedReportList || []).length > 0) {
        setListCol([
          { w: colW[1], t: '項次', f: 'itemNo' },
          { w: colW[8], t: '船名', f: 'vesselName' },
          { w: colW[8], t: '航次', f: 'voyageNo' },
          { w: colW[4], t: '船隻掛號', f: 'vesselRegNo' },
          { w: colW[4], t: '艙單號碼', f: 'manifNo' },
          { w: colW[8], t: '貨櫃號碼', f: 'containerNo' },
          { w: colW[4], t: '櫃型(呎)', f: 'containerType' },
          { w: colW[4], t: '申報件數', f: 'manifPiece' },
          { w: colW[4], t: '實到件數', f: 'gciPiece' },
          { w: colW[4], t: '短卸(件)', f: 'shortPiece' },
          { w: colW[4], t: '溢卸(件)', f: 'overPiece' },
        ]);
        if (
          (shortOverLandedReportList[0].shortOverLandedDetails || []).length > 0
        ) {
          setListColDetail([
            { w: 20, t: '項次', f: 'itemNo' },
            { w: colW[4], t: '船隻掛號', f: 'vesselRegNo' },
            { w: colW[8], t: '貨櫃號碼', f: 'containerNo' },
            { w: colW[8], t: '分提單號', f: 'hawbNo' },
            { w: colW[4], t: '短卸(件)', f: 'shortPiece' },
            { w: colW[4], t: '溢卸(件)', f: 'overPiece' },
          ]);
          setRowDataDetail(shortOverLandedReportList[0].shortOverLandedDetails);
        }
        setRowData(shortOverLandedReportList);
        setOpenSearchTable(true);
      } else {
        setOpenSearchTable(false);
      }
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleExportShortExcelFile = async (
    e?: React.FormEvent<HTMLFormElement>
  ) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await postExcelAndFunctionName(
      apiName,
      'exportShortExcelFile',
      {
        warehouse: master.warehouse,
        shortOverType: master.shortOverType,
        mawbNo: master.mawbNo,
        declDate: master.declDate,
      }
    );
    const declDate = formatDate(master.declDate, 'yyyyMMdd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${master.warehouse}${declDate}_${
        master.shortOverType === 'S' ? '短卸' : '溢卸'
      }報表.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleExportOverExcelFile = async (
    e?: React.FormEvent<HTMLFormElement>
  ) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await postExcelAndFunctionName(
      apiName,
      'exportOverExcelFile',
      {
        warehouse: master.warehouse,
        shortOverType: master.shortOverType,
        mawbNo: master.mawbNo,
        declDate: master.declDate,
      }
    );
    const declDate = formatDate(master.declDate, 'yyyyMMdd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${master.warehouse}${declDate}_${
        master.shortOverType === 'S' ? '短卸' : '溢卸'
      }報表.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };
  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.mawbNo.length === 0) {
      enqueueSnackbar('【主號】必填。', {
        variant: 'warning',
      });
      return;
    }
    if (master.declDate.length === 0) {
      master.declDate = getDateDayPlus();
    }
    if (!master.declDateValid || !master.declDate) {
      return;
    }
    switch (submitKey) {
      case 'search':
        setShowDetail(false);
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      case 'exportShortExcelFile':
        handleExportShortExcelFile();
        break;
      case 'exportOverExcelFile':
        handleExportOverExcelFile();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      setFormError(warehouseResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setShowDetail(false);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
  };
  const handleShowDetail = async () => {
    setShowDetail(true);
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">分提單查詢</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 短溢卸報表
          </div>
        </div>
        <div className="input-area">
          <div>
            {/* 20210325 新增權限判斷 */}
            {false && (
              <Grid container>
                <VcEGrid item xs={12} sm={2} className="input-text">
                  記帳代號：
                </VcEGrid>

                <VcGrid item xs={12} sm={2}>
                  <Input
                    name="chkCode1"
                    disabled={userTypeList.type2.indexOf(userType) !== -1}
                    maxLength={4}
                    value={master.chkCode1}
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </VcGrid>
                <VcGrid item xs={12} sm={3}>
                  {expressName && (
                    <Alert
                      style={{
                        width: '100%',
                        color: 'red',
                        margin: '0 0.5rem',
                        fontSize: '1em',
                      }}
                      severity="info"
                      icon={false}
                    >
                      {expressName}
                    </Alert>
                  )}
                </VcGrid>
              </Grid>
            )}
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>
                  {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                    userType
                  ) !== -1
                    ? '*'
                    : ''}
                  快遞倉站：
                </FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={2}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={3}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*查詢選項：</FormTitle>
              </VcEGrid>
              <HVcGrid item xs={12} sm={2}>
                <Radio
                  className="input-radio "
                  required
                  name="shortOverType"
                  value={master.shortOverType}
                  onChange={(e, value) => {
                    radioChange(updateData)(e, value);
                  }}
                  options={[
                    { value: 'S', label: '短卸' },
                    { value: 'O', label: '溢卸' },
                  ]}
                />
              </HVcGrid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*拆櫃日期：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
                <DateOneSePickersTyping
                  required
                  updateData={updateData}
                  style={{ maxWidth: 200 }}
                  inputDataName="declDate"
                  data={master}
                  seInterval={31}
                />
              </VcGrid>
            </Grid>
          </div>

          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*主號：</FormTitle>
              </VcEGrid>
              <Grid item xs={12} sm={3}>
                {/* <Input
                  maxLength={35}
                  value={master.mawbNo}
                  name="mawbNo"
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                /> */}
                <Autocomplete
                  inputValue={master.mawbNo}
                  onInputChange={(event, newInputValue) => {
                    setMaster((prev) => ({
                      ...prev,
                      mawbNo: newInputValue,
                    }));
                  }}
                  options={mawbNoList}
                  renderInput={(params) => (
                    <TextField {...params} label="請選擇…" />
                  )}
                />
              </Grid>
            </Grid>
          </div>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError || master.shortOverType === 'O'}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('exportShortExcelFile')}
            >
              下載短卸
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError || master.shortOverType === 'O'}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載短卸明細表
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError || master.shortOverType === 'S'}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('exportOverExcelFile')}
            >
              下載溢卸
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError || !openSearchTable}
              variant="outlined"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => handleShowDetail()}
            >
              查詢明細
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <>
          <NewTable<IshortOverLandedList>
            data={rowData}
            columns={listCol}
            pageSize={100}
            pageSizeOptions={[100, 50, 10]}
          />
          {showDetail && (
            <NewTable<IshortOverLandedDetailList>
              data={rowDataDetail}
              columns={listColDetail}
              pageSize={100}
              pageSizeOptions={[100, 50, 10]}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ShortOverLandedQry;
